/**
 * Detects browser language and returns appropriate UI locale for Azure AD B2C
 * Returns 'fr' if browser language is French, 'en' otherwise
 * 
 * @returns 'fr' for French browsers, 'en' for all others
 */
export function getBrowserUILocale(): string {
  const browserLang = navigator.languages && navigator.languages.length > 0
    ? navigator.languages[0]
    : (navigator.language || (navigator as any).userLanguage || (navigator as any).browserLanguage || 'en');
  
  // Check if primary language is French (fr-FR, fr-CA, fr, etc.)
  const langCode = browserLang.toLowerCase().split('-')[0];
  return langCode === 'fr' ? 'fr' : 'en';
}

